// src/api/dashboard.ts

import axiosInstance from './axiosInstance';

export interface DashboardResponse {
  totalUserCount: number;
  adjusterCount: number;
  customerScore: number;
}

// 👇 여기에서 명시적으로 타입 지정
export const fetchDashboardData = async (): Promise<DashboardResponse> => {
  const response = await axiosInstance.get<DashboardResponse>('/api/allbadeum/v1/dashboard');
  return response.data;
};
